export default "__VITE_ASSET__7opeII1___"